var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-notify',{attrs:{"type":_vm.notice.type},model:{value:(_vm.notice.show),callback:function ($$v) {_vm.$set(_vm.notice, "show", $$v)},expression:"notice.show"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.notice.message)}})])}
var staticRenderFns = []

export { render, staticRenderFns }